import { AUTH_SERVER_TOKEN } from './auth-server-token';
import { HttpClient, HttpResponse, HttpHeaders, HttpParams, HttpParameterCodec } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { PostAuthDTO, AuthenticationType } from '@portal-front-end/models';
import { delay } from 'rxjs/operators';
import { environment } from '../../../../../../apps/portal-front-end/src/environments/environment';

@Injectable({ providedIn: 'root' })

export class AuthenticationApiService {
    authorizationHeader = btoa(environment.clientCredentials);

    constructor(
        private readonly http: HttpClient,
        @Inject(AUTH_SERVER_TOKEN) private authServer: string,
    ) { }

    login(loginData: { username: string, password: string }): Observable<AuthenticationType> {
        const loginDTO = new HttpParams({encoder: new CustomEncoder()})
            .set('username', loginData.username.trim())
            .set('password', loginData.password)
            .set('grant_type', 'password')
            .set('scope', 'read write');
        return this.http.post<AuthenticationType>(`${this.authServer}/oauth/token`, loginDTO, {
            headers: {
                Authorization: `Basic ${this.authorizationHeader}`
            }
        });
    }

    forgotPasswordRequest(resetData: { email: string }): Observable<any> {
        return this.http.post<any>(`${this.authServer}/user/reset-password/request?email=${resetData.email.trim()}`, {});
    }

    resetPassword(resetData: { token: string, password: string }): Observable<any> {
        return this.http.post<any>(`${this.authServer}/user/reset-password`, resetData);
    }

    refreshAccessToken(refreshToken: string): Observable<any> {
        const refreshData = new HttpParams()
            .set('refresh_token', refreshToken)
            .set('grant_type', 'refresh_token')
            .set('scope', 'read write');
        return this.http.post<AuthenticationType>(`${this.authServer}/oauth/token`, refreshData, {
            headers: {
                Authorization: `Basic ${this.authorizationHeader}`
            }
        });
    }

    validateToken(token: string): Observable<boolean> {
        return of(true).pipe(delay(1000));
    }
}

// https://github.com/angular/angular/issues/18261#issuecomment-338354119
class CustomEncoder implements HttpParameterCodec {
    encodeKey(key: string): string {
        return encodeURIComponent(key);
    }

    encodeValue(value: string): string {
        return encodeURIComponent(value);
    }

    decodeKey(key: string): string {
        return decodeURIComponent(key);
    }

    decodeValue(value: string): string {
        return decodeURIComponent(value);
    }
}
